import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ExtraPaddingModel } from '../../models';
import { PdfSettingsSizeEnum } from '../../enums';

@Component({
  selector: 'rnpl-pdf-spacer',
  templateUrl: './pdf-spacer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfSpacerComponent {

  public pdfSettingsSizeEnum = PdfSettingsSizeEnum;

  @Input() extraPadding: ExtraPaddingModel;

  public defaultSizes = {
    [PdfSettingsSizeEnum.NONE]: 0,
    [PdfSettingsSizeEnum.SMALL]: 16,
    [PdfSettingsSizeEnum.MEDIUM]: 32,
    [PdfSettingsSizeEnum.LARGE]: 64,
  };

}
